import { connect } from 'react-redux';
import type { ActionCreator } from 'redux';
import type { OverrideValues, AccommodationState } from '@/interfaces';
import { actions } from '@/state/filterActions';
import { fetchHotels } from '@/ducks/searchResults/actions';
import {
    type SelectedCheckboxDispatchProps,
    SelectedCheckboxFilter,
    type SelectedCheckboxStateProps,
} from '../../../../components/selectedCheckboxFilter/SelectedCheckboxFilter';
import { mapChains } from './HotelChainFilter';

export const mapStateToProps = (state: AccommodationState): SelectedCheckboxStateProps => ({
    id: 'HotelChainFilter',
    facetList: mapChains([...state.searchResults.chains]),
    checkboxValues: state.filters.hotelChain,
});

export const mapDispatchToProps: OverrideValues<SelectedCheckboxDispatchProps, ActionCreator<unknown>> = {
    checkBoxClick: actions.filterHotelChain,
    triggerFetch: fetchHotels,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectedCheckboxFilter);
